import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Guarantee from "@/components/Guarantee";
import SuccessStories from "@/components/SuccessStories";
import Founders from "@/components/Founders";
import IntakeForm from "@/components/IntakeForm";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div className="bg-basalt" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Guarantee />
        <SuccessStories />
        <Founders />
        <IntakeForm />
      </main>
      <Footer />
    </div>
  );
}
